/*
 * @Author: WangChao
 * @Date: 2025-06-02 11:56:11
 * @LastEditors: WangChao
 * @LastEditTime: 2026-08-25 16:49:11
 * @FilePath: \travel_ai\src\lib\pmessage.js
 * @Description:
 */
class Pmessage {
  flushcb = {};
  constructor() {
    this.flushcb = {};
  }
  // option = { frameName, action, data}
  messageCb(e) {
    if (e.origin === "http://localhost:8081" || (e !== null && typeof e.data === 'object')) {
      // 防止开发环境一直接收到消息
      return false;
    }
    console.log("YKB: 接收来自ECS数据成功:", e);
    let orginalData = {};
    try {
      orginalData = JSON.parse(e.data);
    } catch (err) {
      console.log(err);
    }
    const { frameName = "", extend = {}, msgId = "" } = orginalData;
    const action = extend.msgId || msgId;
    const cb = action && this.flushcb[frameName + action];
    cb && typeof cb === "function" && cb(e);
  }
  addEvent() {
    console.log("message addEventListener");
    window.addEventListener("message", this.messageCb.bind(this));
  }
  send(option, targetFrame = window.parent) {
    // 默认是 向父 window发消息
    targetFrame.postMessage(JSON.stringify(option), "*");
  }
  // 注册某一行为的回调
  registAction(option, callback) {
    // 默认监听 父window发处的消息
    const { frameName = "", action } = option;
    this.flushcb[frameName + action] = callback;
  }
  // 清空某一行为的回调，有值清除指定的，
  clearAction(option) {
    if (!option) {
      this.flushcb = {};
    } else {
      const { frameName = "", action } = option;
      this.flushcb[frameName + action] = null;
      delete this.flushcb[frameName + action];
    }
  }
  destroy() {
    console.log("取消postMessage监听");
    window.removeEventListener("message", this.messageCb, false);
  }
}
// let store = new LocalStorage()
const pm = new Pmessage();
pm.addEvent();
const newPmessage = (vue) => {
  vue.prototype.$pm = pm;
};
export default newPmessage;
